import React from 'react';
import PropTypes from 'prop-types';
import IconOutlineButton from './IconOutlineButton';
import { REFERRAL, APPOINTMENT_STATUS, APPOINTMENT_DISPOSITIONS } from '_constants';

const PendingAppointmentOutcome = ({ ...props }) => {
  PendingAppointmentOutcome.propTypes = {
    gotoDetailCard: PropTypes.func.isRequired,
    updateAppointmentStatus: PropTypes.func.isRequired
  };

  return (
    <React.Fragment>

      <div className='d-flex justify-content-around w-100'>
        <IconOutlineButton
          className='m-1 text-center'
          iconName='material-icons material-icons-chat-bubble-outline'
          iconSize='h3 btn-outline-icon-1'
          label='Made <br/>Contact'
          onClick={() => props.updateAppointmentStatus(APPOINTMENT_STATUS.MADE_CONTACT.id, APPOINTMENT_DISPOSITIONS.AGENT_MADE_CONTACT, REFERRAL.PENDING_APPOINTMENT_STATUS, 'Successfully Made Contact', 'Error on Made Contact')}
        />

        <IconOutlineButton
          className='m-1 text-center'
          iconName='material-icons material-icons-phone-iphone'
          iconSize='h3 btn-outline-icon-2'
          label='Left <br/>Message'
          onClick={() => props.updateAppointmentStatus(APPOINTMENT_STATUS.LEFT_MESSAGE.id, APPOINTMENT_DISPOSITIONS.AGENT_MADE_CONTACT, REFERRAL.CALL_NOW, 'Left Message for the lead', 'Error on Left Message')}
        />

        <IconOutlineButton
          className='m-1 text-center'
          iconName='material-icons material-icons-close'
          iconSize='h3 btn-outline-icon-3'
          label="Couldn't <br/>Reach"
          onClick={() => props.updateAppointmentStatus(APPOINTMENT_STATUS.COULDNT_REACH.id, APPOINTMENT_DISPOSITIONS.AGENT_MADE_CONTACT, REFERRAL.CALL_NOW, 'Could not reach the lead', 'Error on Couldn\'t Reach')}
        />
      </div>
    </React.Fragment>
  );
};

export default PendingAppointmentOutcome;
